export default class Book{
    constructor() {
        this.id = "";
        this.dateIn = "";
        this.dateOut = "";
        this.rooms = [];
        this.customer = {};
        this.adults = 0;
        this.kids = 0;
        this.status = BOOK_STATUS.BOOKING;
    }
}

const BOOK_STATUS = {
    BOOKING: 0,
    BOOKED: 1,
    GUEST_NOW: 2,
    PAID: 3
}